module.exports = __webpack_public_path__ + "img/data.cd901442.svg";